import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // ⏳ Wait until user is loaded
  if (loading) {
    return <div>Loading...</div>;
  }

  // 🚫 Not logged in OR not admin
  if (!user || user.role !== 'admin') {
    return <Navigate to="/" />;
  }

  return children;
};

export default AdminRoute;